import { Radio } from 'antd'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function AllActiveInactive({ value, onChange = () => null }) {
  const { t } = useTranslate()

  const options = [
    { label: t('All'), value: 'all' },
    { label: t('Active'), value: 'active' },
    { label: t('Inactive'), value: 'inactive' },
  ]

  const radioGroupProps = {
    defaultValue: 'all',
    options,
    optionType: 'button',
    buttonStyle: 'solid',
  }

  if (value) {
    radioGroupProps.value = value
    radioGroupProps.onChange = (e) => {
      onChange(e.target.value)
    }
  }

  return (
    <Styled className="all-active-inactive-component">
      <Radio.Group {...radioGroupProps} />
    </Styled>
  )
}
